import { TERMS_MODULE_OPTINS } from "../../../../components/modules/compliance/config";
import { flowBRDisabledInternationalBorrower } from "../../flowBRDisabledInternationalBorrower";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { flowWelcomeAndTerms } from "../../flowWelcomeAndTerms";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const upfFlows = [
  {
    ...flowDisabledLoan,
    condition: (processState, authState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowWelcomeAndTerms,
    condition: (processState, authState) => {
      return (
        !processState.participant.participantId ||
        !processState?.optIns ||
        processState?.optIns?.conditions_indicated
          .filter((condition) =>
            TERMS_MODULE_OPTINS.includes(condition.condition_type)
          )
          .some((condition) => condition.required && condition.checked !== true)
      );
    },
  },
  {
    ...flowBRDisabledInternationalBorrower,
    condition: () => {
      return true;
    },
  },
];
